export function generateSlug(str) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/['\s\W-]+/g, "-")
    .replace(/-+/g, "-");
}
